module.exports = __webpack_public_path__ + "static/media/alvsjo.b0e88ec0.png";